import type { FCC } from '../../../../types';

export const FormSection: FCC = ({ children }) => {
    return <div className={'flex w-full flex-col rounded-md'}>{children}</div>;
};